import Vue from 'vue';
import {
  FontAwesomeIcon,
  FontAwesomeLayersText,
  FontAwesomeLayers,
} from '@fortawesome/vue-fontawesome';
import BaseAppFooter from '../components/base/BaseAppFooter';
import BasePagination from '../components/base/BasePagination';
import BaseTable from '../components/base/BaseTable';
import Multiselect from 'vue-multiselect';
import BaseComponentLoader from '../components/base/BaseComponentLoader';
import BaseModal from '../components/base/mdoals/BaseModal';

import BaseCommentCard from "@/components/base/comment/BaseCommentCard";
import BaseButton from '../components/base/buttons/BaseButton';
import BaseModalButton from '../components/base/buttons/BaseModalButton';


//region btn default move all atr. on BaseButton
import BasePrimaryButton from "@/components/base/buttons/bin/BasePrimaryButton";
import BaseDangerButton from "@/components/base/buttons/bin/BaseDangerButton";
import BaseSecondaryButton from "@/components/base/buttons/bin/BaseSecondaryButton";
import BaseSuccessButton from "@/components/base/buttons/bin/BaseSuccessButton";
import BaseInfoButton from "@/components/base/buttons/bin/BaseInfoButton";
//endregion

//region btn outline move all atr. on BaseButton
import BaseOutlineDangerButton from "@/components/base/buttons/bin/BaseOutlineDangerButton";
import BaseOutlineInfoButton from "@/components/base/buttons/bin/BaseOutlineInfoButton";
import BaseOutlinePrimaryButton from "@/components/base/buttons/bin/BaseOutlinePrimaryButton";
import BaseOutlineSecondaryButton from "@/components/base/buttons/bin/BaseOutlineSecondaryButton";
import BaseOutlineSuccessButton from "@/components/base/buttons/bin/BaseOutlineSuccessButton";
import BaseWarningButton from "@/components/base/buttons/bin/BaseWarningButton";
import BaseOutlineWarningButton from "@/components/base/buttons/bin/BaseOutlineWarningButton";
//endregion

export const ComponentConfig = {
  pluginComponents() {
    Vue.component('font-awesome-icon', FontAwesomeIcon);
    Vue.component('font-awesome-layers', FontAwesomeLayers);
    Vue.component('font-awesome-layers-text', FontAwesomeLayersText);
  },

  baseComponent() {
    Vue.component('base-table', BaseTable);
    Vue.component('base-pagination', BasePagination);
    Vue.component('base-app-footer', BaseAppFooter);
    Vue.component('base-component-loader', BaseComponentLoader);
    Vue.component('base-primary-btn', BasePrimaryButton);
    Vue.component('base-danger-btn', BaseDangerButton);
    Vue.component('base-secondary-btn', BaseSecondaryButton);
    Vue.component('base-success-btn', BaseSuccessButton);
    Vue.component('base-info-btn', BaseInfoButton);
    Vue.component('base-warning-btn', BaseWarningButton);
    Vue.component('base-outline-danger-btn', BaseOutlineDangerButton);
    Vue.component('base-outline-info-btn', BaseOutlineInfoButton);
    Vue.component('base-outline-primary-btn', BaseOutlinePrimaryButton);
    Vue.component('base-outline-secondary-btn', BaseOutlineSecondaryButton);
    Vue.component('base-outline-success-btn', BaseOutlineSuccessButton);
    Vue.component('base-outline-warning-btn', BaseOutlineWarningButton);
    Vue.component('base-modal', BaseModal);
    Vue.component('base-comment-card', BaseCommentCard);

    Vue.component('base-button',BaseButton)
    Vue.component('base-modal-button',BaseModalButton)

    /** vue for multiselect **/
    Vue.component('vue-multiselect',Multiselect)
  },
};

export default {ComponentConfig};
